import { Province, Region } from "@nemuru-eng/js-api-client";
import { postalCodeValidation } from "../../../constants/postalCodeValidation";

export const geocoderToAddressFieldsMapper = (geocode) => {
  const get = (types) =>
    geocode.address_components.find((component) =>
      component.types.find((type) => types.includes(type))
    );

  const streetName =
    get(["route", "street_address", "premise"])?.long_name ?? "";
  const streetNumber = get(["street_number"])?.long_name ?? "";
  const postalCode = get(["postal_code"])?.long_name ?? "";
  const postalCodeSuffix = get(["postal_code_suffix"])?.long_name ?? "";
  const city = get([
    "locality",
    "postal_town",
    "administrative_area_level_3",
  ])?.long_name;
  const country = get(["country"])?.short_name ?? "";
  const countryLongName = get(["country"])?.long_name ?? "";

  const validPostalCode = postalCodeValidation(country, postalCode);

  const province =
    get(["administrative_area_level_2"])?.long_name ??
    (country === "ES" && validPostalCode
      ? Province.createFromPostalCode(postalCode).longName
      : null);
  const provinceShortName =
    get(["administrative_area_level_2"])?.short_name ??
    (country === "ES" && validPostalCode
      ? Province.createFromPostalCode(postalCode).shortName
      : null);
  const regionLongName =
    get(["administrative_area_level_1"])?.long_name ??
    (country === "ES" && validPostalCode
      ? Region.createFromPostalCode(postalCode).longName
      : null);
  const regionShortName =
    get(["administrative_area_level_1"])?.short_name ??
    (country === "ES" && validPostalCode
      ? Region.createFromPostalCode(postalCode).shortName
      : null);

  return {
    streetName,
    streetNumber,
    postalCode: `${postalCode}${postalCodeSuffix ? `${postalCodeSuffix}` : ""}`,
    city,
    province,
    provinceShortName,
    regionLongName,
    regionShortName,
    country,
    countryLongName,
  };
};
